/**
 * List of allowed referrer domains.
 *
 * The accounts app URL has to be specifically excluded, because "accounts" is not an aops test server domain,
 * and the accounts app does redirect to itself when logging in new users, so we want to ignore the referrer in
 * those cases.
 * - accounts.artofproblemsolving.com
 * - accounts.aops.com
 * - accounts.aopstest.com
 * - web-accounts-<...>-aops-ba.vercel.app (removed)
 */
export const ALLOWED_REFERRER_DOMAINS = [
	/^(?!accounts\.artofproblemsolving\.com$)(?:.+\.)?artofproblemsolving\.com$/,
	/^(?!accounts\.aops\.com$)(?:.+\.)?aops\.com$/,
	/^(?!accounts\.aopstest\.com$)(?:.+\.)?aopstest\.com$/,
	/^(.+\.)*aopsacademy\.club$/,
];
export const REFERRING_TEST_SERVER_COOKIE_NAME = "referringTestServer";
export const REFERRING_TEST_SERVER_COOKIE_MAX_AGE = 60 * 60 * 24; // 1 day in seconds
